import { render } from "./ConsultaDocumentoCliente.vue?vue&type=template&id=4dbf65a8&scoped=true"
import script from "./ConsultaDocumentoCliente.vue?vue&type=script&lang=js"
export * from "./ConsultaDocumentoCliente.vue?vue&type=script&lang=js"

import "./ConsultaDocumentoCliente.vue?vue&type=style&index=0&id=4dbf65a8&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbf65a8"]])

export default __exports__